// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1yaOZ","left":"StickyBox_left__2jOj0","right":"StickyBox_right__7N019"};